// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2QZ8n","buttons":"RemoveExpirationActionButtons_buttons__2Sf2K"};